export const defaultAM = {
  logPaths: [
    {
      path: 'C:/Users/Administrator/AppData/Local/UiPath/Logs',
      description: 'Ruta de logs de UiPath',
    },
  ],
};
